import { ROUTE } from '../../../../routes';
import moment from 'moment/moment';
import { getAppHeader, RegexConfig } from '../../../../configs/config';
import SharedPropsService from '../../../../SharedPropsService';
import { ButtonTypeTokens, CalendarStateToken, InputStateToken, WIDGET, } from '@voltmoney/schema';
import { ACTION } from './types';
import { api } from '../../../../configs/api';
import sharedPropsService from "../../../../SharedPropsService";
let pan = '';
let dob = '';
let mobile = '';
let email = '';
export const GoBack = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
//returns whether validation is successful or not
export const ValidateForm = async (action, _datastore, { ...props }) => {
    let isDobComplete = false;
    //1. Store the action value, 2. Validate individual and take action, 3. Take action on form
    switch (action.payload.widgetId) {
        case 'input': {
            pan = action.payload.value;
            break;
        }
        case 'calendarPicker': {
            if (action.payload.value && action.payload.value.length == 10) {
                await sharedPropsService.setUserDobFromCalenderPicker(action.payload.value);
                isDobComplete = true;
            }
            dob = `${moment(action.payload.value, 'DD-MM-yyyy').valueOf()}`;
            break;
        }
        case 'mobileNumberInput': {
            mobile = action.payload.value;
            break;
        }
        case 'emailInput': {
            email = action.payload.value;
            break;
        }
    }
    let currentDate = Date.now();
    let minDate = currentDate - 100 * 31557600000;
    let maxDate = currentDate - 18 * 31557600000;
    const panRegex = new RegExp(RegexConfig.PAN);
    const emailRegex = new RegExp(RegexConfig.NEW_EMAIL);
    const mobileNumber = new RegExp(RegexConfig.NEW_MOBILE);
    let isDobValid = parseInt(dob) >= minDate && parseInt(dob) <= maxDate;
    let isPanValid = panRegex.test(pan);
    let isPhoneNumberValid = mobileNumber.test(mobile);
    let isEmailValid = emailRegex.test(email);
    if (isDobValid) {
        let dobInddMMyyyy = moment.unix(Number(dob) / 1000).format('DD-MM-yyyy');
        await SharedPropsService.setUserDob(dobInddMMyyyy);
        await props.setDatastore(action.routeId, 'calendarPicker', {
            state: CalendarStateToken.DEFAULT,
        });
    }
    else if (isDobComplete) {
        //If dob is not valid but is complete in terms of format dd-MM-yyyy then throw error
        await props.setDatastore(action.routeId, 'calendarPicker', {
            state: CalendarStateToken.ERROR,
        });
    }
    let isValid = isDobValid && isPanValid && isEmailValid && isPhoneNumberValid;
    await toggleCTA({
        type: ACTION.TOGGLE_CTA,
        routeId: action.routeId,
        payload: {
            value: isValid,
            targetWidgetId: 'continueCTA',
        },
    }, {}, props);
};
export const toggleCTA = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, action.payload.targetWidgetId, {
        type: action.payload.value && pan && dob
            ? ButtonTypeTokens.LargeFilled
            : ButtonTypeTokens.LargeOutline,
    });
};
export const NavToNextStep = async (action, _datastore, { instrumentTrack, removeWidgets, network, asyncStorage, setDatastore, navigate, handleError, ...props }) => {
    instrumentTrack("JOINT_HOLDER_KYC_BASIC_DETAILS_ADDED");
    const user = await SharedPropsService.getUser();
    //Verifying PAN and opening confirmation modal.
    await setDatastore(action.routeId, 'continueCTA', {
        label: '',
        type: ButtonTypeTokens.LargeOutline,
        loading: true,
    });
    await removeWidgets(ROUTE.CO_BORROWER_KYC_DIGIO_BASE, [
        { id: 'coBorrowerKycVerificationPage', type: WIDGET.CO_BORROWER_KYC_VERIFICATION },
    ]);
    await network
        .post(api.borrowerPANValidate, {
        panNumber: `${pan}`,
    }, { headers: await getAppHeader() })
        .then(async (response) => {
        await setDatastore(action.routeId, 'continueCTA', {
            label: 'Continue',
            type: ButtonTypeTokens.LargeFilled,
            loading: false,
        });
        await navigate(ROUTE.CO_BORROWER_PAN_CONFIRM_NAME, {
            name: response?.data.fullName,
            panNumber: response?.data.panNumber,
            dob: dob,
            mobileNumber: `+91${mobile}`,
            emailId: email,
        });
    })
        .catch(async (error) => {
        await setDatastore(action.routeId, 'continueCTA', {
            label: 'Continue',
            type: ButtonTypeTokens.LargeOutline,
            loading: false,
        });
        await setDatastore(action.routeId, 'input', {
            state: InputStateToken.ERROR,
        });
    });
};
